/**
 * AI応答のマークダウンをHTMLに変換
 */

function escapeHtml(text) {
  if (!text) return '';
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

export function stripEmoji(str) {
  if (!str) return '';
  return str.replace(/[\u{1F300}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F4A1}\u{2728}\u{1F536}\u{1F538}\u{1F3AF}\u{2B50}\u{1F4CC}\u{1F4DD}\u{1F3AC}\u{1F4CA}\u{1F4C8}]/gu, '');
}

export function parseMarkdown(text) {
  if (!text) return '';
  // 絵文字除去 + 改行コード正規化（\r\n → \n）+ 前後トリム
  let html = stripEmoji(text).replace(/\r\n/g, '\n').replace(/\r/g, '\n').trim();
  if (!html) return '';

  // 1. コードブロックを保護
  const codeBlocks = [];
  html = html.replace(/```[\s\S]*?```/g, (match) => {
    codeBlocks.push(match);
    return `__CODE_BLOCK_${codeBlocks.length - 1}__`;
  });

  // 2. インラインコードを保護
  const inlineCodes = [];
  html = html.replace(/`([^`]+)`/g, (match) => {
    inlineCodes.push(match);
    return `__INLINE_CODE_${inlineCodes.length - 1}__`;
  });

  // 3. 水平線
  html = html.replace(/^(---|\*\*\*)\s*$/gm, '<hr class="border-0 border-t border-gray-200 my-4">');

  // 4. 見出し（h6→h1の順で処理、スタイルはCSSで管理）
  html = html.replace(/^######\s+(.+)$/gm, (_, title) => `<h6>${title}</h6>`);
  html = html.replace(/^#####\s+(.+)$/gm, (_, title) => `<h5>${title}</h5>`);
  html = html.replace(/^####\s+(.+)$/gm,  (_, title) => `<h4>${title}</h4>`);
  html = html.replace(/^###\s+(.+)$/gm,   (_, title) => `<h3>${title}</h3>`);
  html = html.replace(/^##\s+(.+)$/gm,    (_, title) => `<h2>${title}</h2>`);
  html = html.replace(/^#\s+(.+)$/gm,     (_, title) => `<h1>${title}</h1>`);

  // 5. 太字（スタイルはCSSで管理）
  html = html.replace(/\*\*((?!\*)[^*]*(?:\*(?!\*)[^*]*)*)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/__((?!_)[^_]*(?:_(?!_)[^_]*)*?)__/g, '<strong>$1</strong>');

  // 6. 箇条書き（行頭の任意スペース後に - / * / ・）
  html = html.replace(/^\s*[-*・]\s+(.+)$/gmu, '<li>$1</li>');

  // 7. 番号付きリスト
  html = html.replace(/^\s*(\d+)\.\s+(.+)$/gmu, '<li class="list-decimal">$2</li>');

  // 8. リンク
  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" class="text-[#37acdb] hover:underline" target="_blank">$1</a>');

  // 9. 改行 → <br>
  html = html.replace(/\n/g, '<br>');

  // 9b. ブロック要素前後の余分な <br> を除去
  const blockTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'hr', 'pre', 'p'];
  blockTags.forEach(tag => {
    html = html.replace(new RegExp(`(<br>)+(<${tag}[\\s>])`, 'g'), '$2');
    html = html.replace(new RegExp(`(</${tag}>)(<br>)+`, 'g'), '$1');
  });

  // 先頭の余分な <br> を除去
  html = html.replace(/^(<br>)+/, '');

  // 連続する <br> を最大2つに制限
  html = html.replace(/(<br>){3,}/g, '<br><br>');

  // 10. 連続する li を ul/ol でラップ
  html = html.replace(/(<li[^>]*>[\s\S]*?<\/li>(?:<br>)*)+/g, (match) => {
    const items = match.replace(/<br>/g, '');
    const isOl = /<li class="list-decimal/.test(items);
    const tag = isOl ? 'ol' : 'ul';
    return `<${tag}>${items}</${tag}>`;
  });

  // 11. コードブロック復元
  codeBlocks.forEach((block, i) => {
    const content = block.replace(/^```\w*\n?/, '').replace(/\n?```$/, '');
    html = html.replace(`__CODE_BLOCK_${i}__`, `<pre class="bg-gray-100 rounded-lg p-4 my-3 overflow-x-auto text-sm"><code>${escapeHtml(content)}</code></pre>`);
  });

  // 12. インラインコード復元
  inlineCodes.forEach((code, i) => {
    const content = code.replace(/`([^`]+)`/, '$1');
    html = html.replace(`__INLINE_CODE_${i}__`, `<code class="bg-gray-100 px-1.5 py-0.5 rounded text-sm font-mono">${escapeHtml(content)}</code>`);
  });

  return html;
}
